import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { Currency, PagedResponseCurrency } from '../models/Currency';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class CurrencyService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getCurrencies():Observable<PagedResponseCurrency>{
    const data =  this.http.get<PagedResponseCurrency>(this.APIURL+'/Currency' + '?PageNumber=1&PageSize=100');
    this.messageService.add('Currency Service: fetched Currency');
    return data;
  }

  getCurrency(id: number): Observable<Currency> {
        const Currency =this.http.get<Currency>(this.APIURL+'/Currency/' + id);
    this.messageService.add(`Currency Service: fetched Currency with id=${id}`);
    return Currency;
  }
}